mutation LookupCorporateAccountDelete(
  $input: LookupCorporateAccountDeleteInput!
) {
  lookupCorporateAccountDelete(input: $input) {
    clientMutationId
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
